import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';

@Component({
    templateUrl: './login-view.component.html',
    styleUrls: ['./login-view.component.css']
})
export class LoginViewComponent {
    model: any = {};
    error = '';

    constructor(private router: Router,
                private authenticationService: AuthenticationService) {
    }

    login() {
        this.authenticationService.login(this.model.username, this.model.password)
            .subscribe(result => {
                    if (result === true) {
                        this.authenticationService.getUserInfo().subscribe(() => {
                                this.router.navigate(['/']);
                            }
                        );
                    } else {
                        this.error = 'Usuario o contraseña incorrecto';
                    }
                },
                error => {
                    this.error = error;
                });
    }
}



// WEBPACK FOOTER //
// ./src/app/_shared/login-view/login-view.component.ts